export enum IdProducto {
  PRODUCTO_PROTECCION_DIGITAL_PERSONAS = 'ProductoProteccionDigitalPersonas',
  PRODUCTO_VIDA = 'ProductoVida',
  PRODUCTO_SALUD_DIGITAL = 'ProductoSaludDigital',
  PRODUCTO_SOAT = 'SOAT',
  PRODUCTO_SOAT_FLUJO_VENTA = 'ProductoSoat',
  PRODUCTO_PAC = 'ProductoPac',
  PRODUCTO_VIAJES = 'ProductoViajesMov',
  PRODUCTO_ARRENDAMIENTO = 'ProductoArrendamientos',
  PRODUCTO_ARRENDAMIENTO_RENOVACION = 'ProductoRenovacionArrendamientos',
  PRODUCTO_UNKNOWN = 'unknown',
}
